import { render } from "./CardClinicianSession.vue?vue&type=template&id=e79564b4&scoped=true"
import script from "./CardClinicianSession.vue?vue&type=script&lang=js"
export * from "./CardClinicianSession.vue?vue&type=script&lang=js"

import "./CardClinicianSession.vue?vue&type=style&index=0&id=e79564b4&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e79564b4"]])

export default __exports__